import PreviewModalNavigationButtons from './PreviewModalNavigationButtons.component';

export default PreviewModalNavigationButtons;
